import { motion } from "framer-motion";

const SUIT = { S: "♠", H: "♥", D: "♦", C: "♣" };

export function PlayingCard({ card, delay = 0, highlight, testid }) {
  const red = card && (card.suit === "H" || card.suit === "D");
  return (
    <motion.div
      initial={{ rotateY: 90, opacity: 0, y: -12 }}
      animate={{ rotateY: 0, opacity: 1, y: 0 }}
      transition={{ delay, type: "spring", stiffness: 180, damping: 16 }}
      data-testid={testid}
      className={`grid place-items-center h-20 w-14 sm:h-24 sm:w-16 rounded-xl bg-white shadow-lg border-2 ${
        highlight ? "border-amber-400 ring-2 ring-amber-400/60" : "border-white/20"
      }`}
    >
      <div className="flex flex-col items-center leading-none">
        <span className={`font-display text-2xl font-extrabold ${red ? "text-rose-600" : "text-slate-900"}`}>
          {card?.rank}
        </span>
        <span className={`text-2xl ${red ? "text-rose-600" : "text-slate-900"}`}>{SUIT[card?.suit]}</span>
      </div>
    </motion.div>
  );
}

export function CardBack({ testid }) {
  return (
    <div
      data-testid={testid}
      className="h-20 w-14 sm:h-24 sm:w-16 rounded-xl border-2 border-amber-500/40 bg-gradient-to-br from-purple-800 to-slate-900 grid place-items-center"
    >
      <div className="h-12 w-8 rounded-md border border-amber-400/40 bg-[repeating-linear-gradient(45deg,rgba(255,215,0,0.15)_0_4px,transparent_4px_8px)]" />
    </div>
  );
}
